import * as actions_timeclock from 'actions/timeclock-actions';
import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import moment from 'moment';
import { Table } from 'em-table';
import { ModalForm } from 'enspire-manager-framework';
import { confirmDelete } from 'components/common/toolbox';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';

export default function EditTimeClock(props) {

    /* Hooks ------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------*/

    const params = useParams();
	const history = useHistory();
    const dispatch = useDispatch();

    const users = useSelector((store) => store.users);
    const employees = useSelector((store) => store.employees.employees);


    const employee = params['profile_id'] 
        ? _.find(employees, { id: params['profile_id'] }) 
        : _.find(employees, { id: users.user?.profileId });
    
    const [data, setData] = useState([]);

    /* Effects ------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------*/

    useEffect(() => {
		dispatch(actions_timeclock.getTimeClockRaw(params.handle, employee?.contact?.email, params.startdate, params.enddate));

		return () => {
			const unsubscribe = users.time_clock_unsubscribe;
			if (typeof unsubscribe == 'function') unsubscribe();
		};
    }, [employee]);

    useEffect(() => {

        var data = [];
        users.time_entries.forEach((day) => {
            var date = { seconds: moment(day.id, 'YY-MM-DD').format('X') };
            day.entries?.forEach((entry) => {
                let timeIn = moment(entry['time-in']?.seconds, 'X');
                let timeOut = moment(entry['time-out']?.seconds, 'X');
                data.push({
                    date,
                    dateSort: day.id,
                    dateDisplay: moment(day.id, 'YY-MM-DD').format('ddd, MMM D, YYYY'),
                    timeInDate: entry['time-in'],
                    timeIn: (timeIn.isValid()) ? timeIn.format('h:mm a') : '',
                    timeOut: (timeOut.isValid()) ? timeOut.format('h:mm a') : '',
                });
            });
        });
        data = _.orderBy(data, ['date', 'timeInDate'], ['asc', 'asc']);
        setData(data);
    
    }, [users.time_entries]);

    /* Handlers ------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------*/

    const handleAddNew = () => ({ date: moment(params.startdate, 'X').toDate(), timeIn: '', timeOut: '' });

    const handleSaveNew = (newEntry) => {
		dispatch(actions_timeclock.saveNewClockEntry(params.handle, employee?.contact?.email, newEntry));
    };
    const handleEdit = (field, entry, newValue) => {
        console.log(newValue);
		dispatch(actions_timeclock.updateClockEntry(params.handle, employee?.contact?.email, field, entry, newValue));
    };
    const addLine = (item) => {
        let newEntry = { date: moment(item.date?.seconds, 'X').toDate(), timeIn: '', timeOut: '' };
		dispatch(actions_timeclock.saveNewClockEntry(params.handle, employee?.contact?.email, newEntry));
    }
    const handleDelete = (entry) => {
        dispatch(actions_timeclock.deleteClockEntry(params.handle, employee?.contact?.email, entry));
    }
    const validateTime = (entry) => {

        if (entry.value == '' || entry.value == null) return;
        let time = moment(entry.value, 'h:mm a');
        if (!time.isValid()) return 'Please enter valid time';

        let timeIn = (entry.field == 'timeIn') ? entry.value : data[entry.rowIndex].timeIn;
        let timeOut = (entry.field == 'timeOut') ? entry.value :  data[entry.rowIndex].timeOut;

        var beginningTime = moment(timeIn, 'h:mm a');
        var endTime = moment(timeOut, 'h:mm a');
        if (beginningTime.isSameOrAfter(endTime)) {
            if (entry.field == 'timeIn') return 'Time In cannot be set to a time after Time Out'; // true
            if (entry.field == 'timeOut') return 'Time Out cannot be set to a time before Time In'; // true
        }

        // Check TimeIn against Previous TimeOut
        if (entry.field == 'timeIn') {
            if (data[entry.rowIndex - 1] && data[entry.rowIndex - 1].dateSort == data[entry.rowIndex].dateSort) {
                endTime = moment(data[entry.rowIndex + 1].timeOut, 'h:mm a');
                if (beginningTime.isBefore(endTime)) return 'Time In cannot be set to a time before the TimeOut of the previous entry';
            }
        }

        // Check TimeOut against next TimeIn
        if (entry.field == 'timeOut') {
            if (data[entry.rowIndex + 1] && data[entry.rowIndex + 1].dateSort == data[entry.rowIndex].dateSort) {
                beginningTime = moment(data[entry.rowIndex - 1].timeIn, 'h:mm a');
                if (endTime.isAfter(beginningTime)) return 'Time Out cannot be set to a time after the Time In of the next entry';
            }
        }

        return null;
    }


    /* Constants ------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
    
    const columns = [
        { name: 'Date', field: 'date', type: 'date', format: 'ddd, MMM D, YYYY', nowrap: true, edit: { type: 'date', callback: handleEdit, validation_callback: validateTime, clearable: false }, width: 40 },
        { name: 'Time-In', field: 'timeIn', format: 'h:mm a', nowrap: true, edit: { type: 'time-field', format: 'h:mm a', callback: handleEdit, validation_callback: validateTime, clearable: false }, width: 25 },
        { name: 'Time-Out', field: 'timeOut', format: 'h:mm a', nowrap: true, edit: { type: 'time-field', format: 'h:mm a', callback: handleEdit, validation_callback: validateTime, clearable: false }, width: 25 },
        { name: '', field: 'id', type: 'button', button: { name: <i className="fa-solid fa-circle-plus fa-xl"></i>, className: 'btn-default btn-xs float-right', callback: addLine }, width: 10 }
    ];

    /* Render ------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------*/

    return (

        <ModalForm 
            modal_header="Edit Time Clock"
			history={history}
            hide_cancel={ true }
            save_button_title={'Finished'}
            submitFormHandler={ () => { history.goBack(); }}
        >
            <h3 className="mb-n4">{ employee?.contact?.firstName + " " + employee?.contact?.lastName }</h3>
            <Table
                style={{ minHeight: '475px' }}
                button={' + Time Clock Entry '}
                button_callback={handleAddNew}
                button_class={'btn btn-primary btn-sm float-right'}
                data={data}
                id={'id'}
                show_limit={false}
                columns={columns}
                group_by={{ fields: ['dateSort'], direction: ['asc'], display: ['dateDisplay'], collapsible: true, }}
                save_new_callback={handleSaveNew}
                delete={true}
                on_delete={(entry) => confirmDelete("entry", () => handleDelete(entry))}
        />

            {/* { !allLoaded &&
                <button className="btn btn-default btn-block" onClick={handleMore.bind(this)} disabled={admin.activity_log_pending}>
                    { (admin.activity_log_pending)
                        ? <span className="spinner-border spinner-border-sm ml-2" role="status" aria-hidden="true"></span>
                        : 'MORE'
                    }
                </button>
            } */}
        </ModalForm>
    );
};




